import React from "react";
import {
  LegalDocumentLink,
  LegalDocuments,
  StyledFooter,
} from "./Footer.styles";

function Footer() {
  return (
    <StyledFooter>
      {/* <FooterContainer>
        <SiteLinks>
          {footerContent.siteLinks.map((link, index) => (
            <SiteLink to={link.url} key={index}>
              {link.text}
            </SiteLink>
          ))}
        </SiteLinks>
        <FooterTitle>
          <ParseText text={footerContent.title} />
        </FooterTitle>
        <SocialMediaLinks>
          <SocialMediaLink icon={faFacebook} />
          <SocialMediaLink icon={faYoutube} />
          <SocialMediaLink icon={faInstagram} />
        </SocialMediaLinks>
        <GetAppContainer>
          <GetAppContainerTitle>
            {footerContent.getAppContainer.title}
          </GetAppContainerTitle>
          <InstallButtons>
            <InstallButton icon={playStoreIcon} text={"Play Store"} />
            <InstallButton icon={appStoreIcon} text={"App Store"} />
          </InstallButtons>
        </GetAppContainer>
      </FooterContainer> */}
      <LegalDocuments>
        {[
          {
            text: "Teacher's Documentation",
            url: "/docs/TeacherDoc.pdf",
          },
          {
            text: "Install App",
            url: "/install",
            internal: true,
          },
          {
            text: "Teacher Presentation",
            url: "/teacherPresentation",
            internal: true,
          },
          {
            text: "Terms of Service",
            url: "/docs/T&C.pdf",
          },
          {
            text: "Privacy Policy",
            url: "/docs/Tatva_Privacy_Policy.pdf",
          },
          { text: "Disclaimer", url: "/docs/TatvaDisclaimer.pdf" },
        ].map((link, index) => (
          <LegalDocumentLink
            href={link.url}
            key={index}
            target={link.internal ? "_self" : "_blank"}
          >
            {link.text}
          </LegalDocumentLink>
        ))}
      </LegalDocuments>

    </StyledFooter>
  );
}

export default Footer;
